<template>
  <div class="overflow-hidden">
    <div class="float-left overflow-hidden">
      <a-upload
        :file-list="fileList"
        :before-upload="beforeUpload"
        :customRequest="api"
        :accept="accept"
        :disabled="disabled"
        :remove="removeFile"
      >
        <a-button>
          <a-icon type="loading" v-if="loading" />
          <a-icon type="plus" v-else />
          上传
        </a-button>
      </a-upload>
    </div>
  </div>
</template>
<script>
import { previewlink } from '@/utils/tool';
export default {
  props: {
    accept: {
      default: 'image/*',
      type: String,
    },
    disabled: Boolean,
  },
  data() {
    return {
      fileList: [],
      loading: false,
    };
  },
  mounted() {},
  watch: {},
  methods: {
    previewlink,
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < 1024;
      if (!isLt) {
        this.$message.error('上传pdf需小于1G!');
        return false;
      }
      return isLt;
    },
    async api(e) {
      let formData = new FormData();
      formData.append('file', e.file);
      formData.append('where', 'default');
      formData.append('style', '0');
      this.loading = true;
      let res = await this.$uploadfile('/api/v1/file_upload', formData);
      this.fileList.push({
        uid: res.id,
        name: res.filename,
        url: this.$ossUrl + res.pathname,
        status: 'done',
      });
      this.$emit('upload', this.fileList);
      this.loading = false;
    },
    removeFile(file) {
      const index = this.fileList.indexOf(file.file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
      this.$emit('upload', this.fileList);
    },
  },
};
</script>

  